// test1667
(1667 && 0);
